import api from '@pray/shared/utils/api';

export async function updateTag({
  tagId,
  name = undefined,
  description = undefined,
  contentOrder = undefined,
  isSuggested = undefined,
}) {
  if (!tagId) throw Error('Tag ID is required');

  const data = {};

  if (name !== undefined) data.name = name;
  if (description !== undefined) data.description = description;
  // null clears the tag's order back to the default (mixed)
  if (contentOrder !== undefined) data.content_order = contentOrder;
  if (isSuggested !== undefined) data.is_suggested = isSuggested;

  const url = `/web/studio/tags/${tagId}`;
  const response = await api.executePutRequest(url, data);

  return response.data.data;
}
